export default [
    {
        title: 'Fulfillment',
        customIcon: 'FulfillmentSVG',
        children: [
            {
                title: 'Fulfillment List',
                route: 'fulfillment-list',
                path: '/fulfillment/list',
            },
        ]
    }
]